import React from 'react'
import mainData from '../FetchDataLinks'
import UseFetch from '../UseFetch'
import Addv from './Addv'
import RecomendedTopic from './RecomendedTopic'
import RecommendedTopicSkeleton from './RecommendedTopicSkeleton'

function Topics({ url }) {

    let a = 0;

    const { blogs, loading } = UseFetch(mainData.famous)

    return (
        <div className="col-lg-4 trending mt-lg-0 mt-5">
            <div className="topics">
                <h3 className="section-title-left mb-4"> Recommended Topics</h3>
                {loading && Array(4).fill().map(() => {
                    a++;
                    return <RecommendedTopicSkeleton key={`TopicSkeleton${a}`} />
                })}
                {!loading && blogs.map((blog) => {
                    return <RecomendedTopic key={blog.id} cateogary={blog.Cateogary} />
                })}
            </div>
            {url && <div className="sponsers mt-5">
                <h3 className="section-title-left mb-4"> Advertisement</h3>
                <Addv key={`hello`} />
            </div>}
        </div>
    )
}

export default Topics
